exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".textarea-custom-for-gift {\n  max-height: 52px;\n}\n.textarea-custom-for-gift textarea {\n    border: none !important;\n    min-height: 55px;\n    margin-top: 0;\n}\n@media (max-width: 500px) {\n.textarea-custom-for-gift label {\n      top: -10px;\n}\n}\n@media (max-width: 500px) {\n.textarea-custom-for-gift textarea:focus ~ label, .textarea-custom-for-gift textarea:not(.empty) ~ label {\n      top: -27px;\n}\n}\n", ""]);

// exports
